module.exports = __webpack_public_path__ + "img/44.de617d37.jpg";